var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('comentarios',{staticClass:"p-4",attrs:{"comentarios":_vm.getBitacora,"tipo":"disposicion"},on:{"comentar":_vm.enviarComentario}})}
var staticRenderFns = []

export { render, staticRenderFns }